import PropTypes from 'prop-types';

import withTheme from 'core/hocs/withTheme';
import themePropTypes from 'core/utils/prop-types/theme';

import CloseBold from 'core/components/Icon/CloseBold';

import styles from './index.styl';


function ModalWindow(props) {
  const {
    theme: {
      controls: {
        gameCompare: {
          leaderBoard: {
            modalWindow: modalWindowAtoms,
          },
        },
      },
    },
    title,
    text,
    handleClose,
  } = props;

  return (
    <div className={styles.modalWindow}>
      <style jsx>{`
        .${styles.title}
        .text
          font ${modalWindowAtoms.title}
          color ${modalWindowAtoms.color}

        .text
          font ${modalWindowAtoms.text}
      `}</style>
      <div className={styles.title}>{title}</div>
      <div className='text'>
        {text}
      </div>
      <div className={styles.icon} onClick={handleClose}>
        <CloseBold
          width={10}
          height={10}
          fill={modalWindowAtoms.iconFill}
        />
      </div>
    </div>
  );
}

ModalWindow.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  handleClose: PropTypes.func,
  theme: themePropTypes(`
    {
      controls: {
        gameCompare: {
          leaderBoard: {
            modalWindow: {
              color,
              title,
              text
            }
          }
        }
      }
    },
  `),
};


export default withTheme(ModalWindow);
